import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import PublicAnnouncementDetailsView from './publicAnnouncementDetailsView';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import FooterComponent from '../../commons/footer/footerComponent';
import HeaderComponent from '../../commons/header/headerComponent';
import { getCookie } from '../../../utils/cookies';
import api from '../../../utils/api';
import apiResponseMessage from '../../../utils/apiResponse';

class PublicAnnouncementDetailsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            // Which language version of the announcement content is shown.
            // Defaults to and follows the UI language; the dropdown in the
            // view can override it until the UI language changes again.
            language: this.uiToContentLanguage(this.props.i18n?.language),
            announcement: null,
            isLoading: true,
            success: true,
            message: null,
        };
    }

    uiToContentLanguage = (lng) => (lng?.startsWith('en') ? 'EN' : 'FI');

    onUiLanguageChanged = (lng) => {
        this.setState({
            ...this.state,
            ...{
                language: this.uiToContentLanguage(lng),
            },
        });
    };

    render() {
        const {
            isLoading,
            announcement,
            message,
            success,
            language,
        } = this.state;

        if (isLoading) {
            return <PreloaderComponent />;
        }

        return (
            <div>
                <HeaderComponent />
                <PublicAnnouncementDetailsView
                    announcement={announcement}
                    message={message}
                    success={success}
                    isLoading={isLoading}
                    setLanguage={this.setLanguage}
                    language={language}
                />
                <FooterComponent />
            </div>
        );
    }

    setLanguage = (language) => {
        this.setState({
            ...this.state,
            ...{
                language: language,
            },
        });
    };

    async componentDidMount() {
        this.props.i18n.on('languageChanged', this.onUiLanguageChanged);

        try {
            this.setState({ isLoading: true });
            let response = await api.get('/announcement/', {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },
                params: {
                    id: this.state.id,
                },
            });

            this.setState({
                ...this.state,
                ...{
                    isLoading: false,
                    success: true,
                    announcement: response.data,
                },
            });
        } catch (e) {
            this.setState({
                ...this.state,
                ...{
                    success: false,
                    message:
                        apiResponseMessage(e?.response?.data, 'announcements.requestFailed'),
                    isLoading: false,
                },
            });
        }
    }
    componentWillUnmount() {
        this.props.i18n.off('languageChanged', this.onUiLanguageChanged);
    }
}

export default withRouter(withTranslation()(PublicAnnouncementDetailsComponent));
